import { createDemoCourseDocument } from '../CourseCompiler';
export const tournamentPinesMetadata = {
  id: 'tournament-pines',
  name: 'Tournament Pines',
  description: 'A parkland mountain championship with tree-lined strategy and restrained water.',
  tournamentEventId: 'event-1',
};
export const createTournamentPinesDocument = createDemoCourseDocument;
